import { ApiGenericResponse } from "../ApiGenericResponse";
import { ModelInfo } from "../supportObjects/ModelInfo";
import { AxiosResponse } from "axios";
import { TagValues } from "@/model/data/Tag";

export class GetAvailableTagsResponse extends ApiGenericResponse {
    availableTags: TagValues[];

    constructor(response: AxiosResponse) {
        super(response);
        this.availableTags = [];
        if (response.data && response.data.Payload && response.data.Payload.length > 0) {
            response.data.Payload.forEach((e) => {
                var m = new TagValues();
                m.parse(e);
                this.availableTags.push(m);
            });
        }
    }
}
